import {
  faBolt,
  faChartLine,
  faGaugeHigh,
  faMoneyBillTransfer,
  faPowerOff,
  faSackDollar,
  faShop,
  faShoppingBag,
  faSitemap,
  faUserPlus,
  faUsers,
  faIdCard,
  faWallet,
} from "@fortawesome/free-solid-svg-icons";

const _nav = [
  {
    title: "MAIN",
    items: [
      { name: "Dashboard", to: "/dashboard", icon: faGaugeHigh },
      { name: "Activation", to: "/activation", icon: faPowerOff },
      { name: "KYC", to: "/kyc", icon: faIdCard },
    ],
  },

  {
    title: "MY TEAM",
    items: [
      { name: "Add Member", to: "/add-member", icon: faUserPlus },
      { name: "My Team", to: "/my-team", icon: faUsers },
      { name: "Binary Tree", to: "/binary-tree", icon: faSitemap },
      { name: "Activate Member", to: "/activate-member", icon: faBolt },
    ],
  },
  {
    title: "EARNINGS",
    items: [
      { name: "Income Report", to: "/income-reports", icon: faChartLine },
      { name: "Wallet", to: "/wallet", icon: faWallet },
      { name: "Add Funds", to: "/add-funds", icon: faSackDollar },
      { name: "Withdrawals", to: "/withdrawals", icon: faMoneyBillTransfer },
    ],
  },

  {
    title: "SHOPPING",
    items: [
      { name: "My Orders", to: "/my-orders", icon: faShoppingBag },
      {
        name: "Go to Shop",
        // Set REACT_APP_SHOP_URL in .env to enable this link.
        href: process.env.REACT_APP_SHOP_URL || "",
        icon: faShop,
      },
    ],
  },
];

export default _nav;
